import Api from './api';

export default {
  getTransactions: (data) => Api.get('transactions', data),
};
